
import { Button } from "./button"
import Stream from "./frp/stream"
import { fieldName } from "./utils"
import { Image } from "utils"
import SETTINGS from "settings"
import { TYPE } from 'network/network_api'


export function literal_price( value, precision, delimiter )
{
    value = value.toString()
    while ( value.length < precision + 1 ) value = "0" + value
    //was told that currency should not have delimiter printed in it if it has no fractional part:
    const integer_part = value.slice( 0, - precision )
    const fraction_part = value.slice( - precision )
    value = integer_part
    if ( fraction_part.length > 0 ) value += delimiter
    value += fraction_part
    return value
}

export function progressive_jackpot_panel( space, container, config, $visible )
{
    const ingamePanel = Image( config.background )
    ingamePanel.position.set( config.position.x, config.position.y );
    ingamePanel.scale.set( config.scale || 1.0 );
    container.addChild(ingamePanel);
    
    const FONT = 'jp_panel_font'

    let coinIcon = null;
    if (config.coinIcon) {
        coinIcon = Image(config.coinIcon.texture);
        coinIcon.position.set(config.coinIcon.position.x, config.coinIcon.position.y);
        ingamePanel.addChild(coinIcon);
    }

    const coinText = new PIXI.BitmapText('0', {font: config.coin_font || FONT } )
    coinText.position.set( ... config.coin )
    ingamePanel.addChild(coinText);

    let banknotesIcon = null;
    if (config.banknotesIcon) {
        banknotesIcon = Image(config.banknotesIcon.texture);
        banknotesIcon.position.set(config.banknotesIcon.position.x, config.banknotesIcon.position.y);
        ingamePanel.addChild(banknotesIcon);
    }

    const banknotesText = new PIXI.BitmapText('0', {font: config.banknotes_font || FONT } )
    banknotesText.position.set( ... config.banknotes )
    ingamePanel.addChild(banknotesText);

    let diamondsIcon = null;
    if (config.diamondsIcon) {
        diamondsIcon = Image(config.diamondsIcon.texture);
        diamondsIcon.position.set(config.diamondsIcon.position.x, config.diamondsIcon.position.y);
        ingamePanel.addChild(diamondsIcon);
    }

    const diamondsText = new PIXI.BitmapText('0', {font: config.diamonds_font || FONT } )
    diamondsText.position.set( ... config.diamonds )
    ingamePanel.addChild(diamondsText);

    let startsIcon = null;
    if (config.startsIcon) {
        startsIcon = Image(config.startsIcon.texture);
        startsIcon.position.set(config.startsIcon.position.x, config.startsIcon.position.y);
        ingamePanel.addChild(startsIcon);
    }

    const startsText = new PIXI.BitmapText('0', {font: config.starts_font || FONT } )
    startsText.position.set( ... config.starts )
    ingamePanel.addChild(startsText);

    // space.s('setCoinParam')
    //     .on(param => {
    //         for (let p in param) {
    //             if (coinIcon && coinIcon[p]) coinIcon[p] = param[p];
    //             if (coinText[p]) coinText[p] = param[p];
    //         }
    //     });
    //
    // space.s('setBanknotesParam')
    //     .on(param => {
    //         for (let p in param) {
    //             if (banknotesIcon && banknotesIcon[p]) banknotesIcon[p] = param[p];
    //             if (banknotesText[p]) banknotesText[p] = param[p];
    //         }
    //     });
    //
    // space.s('setDiamondsParam')
    //     .on(param => {
    //         for (let p in param) {
    //             if (diamondsIcon && diamondsIcon[p]) diamondsIcon[p] = param[p];
    //             if (diamondsText[p]) diamondsText[p] = param[p];
    //         }
    //     });
    //
    // space.s('setStartsParam')
    //     .on(param => {
    //         for (let p in param) {
    //             if (startsIcon && startsIcon[p]) startsIcon[p] = param[p];
    //             if (startsText[p]) startsText[p] = param[p];
    //         }
    //     });


    //поллинг текущих значений джекпота:
    space.s( "progressive_jackpot" ).on( pj => {

        const precision = ( pj.currency && pj.currency.minor_unit ) ? pj.currency.minor_unit : 0;
        const delimiter = pj.currency ? pj.currency.delimiter : ""

        coinText.text = literal_price( pj.values[ 0 ], precision, delimiter )
        banknotesText.text = literal_price( pj.values[ 1 ], precision, delimiter )
        diamondsText.text = literal_price( pj.values[ 2 ], precision, delimiter )
        startsText.text = literal_price( pj.values[ 3 ], precision, delimiter )

        /*//из доки:
            "enabled": 1,                           если 0 не отображать
            "values": [                             значения
                335,                                jp6
                1952,                               jp7
                17510                               jp8
            ],
            "currency": {                           данные о валюте джекпотов  (должно быть эквивалентно валюте игрока )
                "id": 643,
                "code_name": "RUB",
                "minor_unit": 2,
                "visible": true
            }
        */
    } )

    space.s( "progressive_jackpot" )
        .any( $visible, ( pj, v ) => ({ pj, v }) )
        .on( ({ pj, v }) => ingamePanel.visible = pj.enabled && v );

    space.s('ui:money_price')
        .any(space.s( "progressive_jackpot" ), (price, pj) => ({price: price, conditions: pj.conditions}))
        .filter(pr => pr.conditions)
        .on(pr => {
            if (coinIcon) coinIcon.alpha = (pr.price < pr.conditions[0]) ? 0.5 : 1.0;
            coinText.alpha = (pr.price < pr.conditions[0]) ? 0.5 : 1.0;

            if (banknotesIcon) banknotesIcon.alpha = (pr.price < pr.conditions[1]) ? 0.5 : 1.0;
            banknotesText.alpha = (pr.price < pr.conditions[1]) ? 0.5 : 1.0;

            if (diamondsIcon) diamondsIcon.alpha = (pr.price < pr.conditions[2]) ? 0.5 : 1.0;
            diamondsText.alpha = (pr.price < pr.conditions[2]) ? 0.5 : 1.0;

            if (startsIcon) startsIcon.alpha = (pr.price < pr.conditions[3]) ? 0.5 : 1.0;
            startsText.alpha = (pr.price < pr.conditions[3]) ? 0.5 : 1.0;
        })
}

export function desc_to_stream( space, desc, name )
{
    let value
    if ( desc === undefined ) value = true
    else
    {
        if ( desc.length ) return Stream.any( ... desc ).map( merge => _.every( merge ) ).name( space, name )
        if ( desc instanceof Stream ) return desc.map( _ => _ ).name( space, name )
        value = desc
    }
    return space.s( name, value )
}

export function makeFrame(description, fontFace)
{
    const frameTexture = description.frame ? PIXI.utils.TextureCache[description.frame] : PIXI.Texture.EMPTY;
    const frame = new PIXI.Sprite(frameTexture);
    frame.position = description.position;
    if ( description.scale ) frame.scale.set( description.scale )

    const label = new PIXI.extras.BitmapText("0", {font: description.font || fontFace});

    const textAlign = description.text_align || {x:0.5, y: 0.5};

    label.anchor.set(textAlign.x, textAlign.y);
    label.position.set(description.text_position.x, description.text_position.y);

    frame.addChild(label);

    return {frame, label};
}

export function makeButton( description, pos )
{
    function texture( name )
    {
        const t = PIXI.utils.TextureCache[ name ]
        if ( ! t )
        {
            console.error( `TEXTURE ${name} NOT FOUND for button; using empty texture` )
            return PIXI.Texture.EMPTY
        }
        return t
    }
    
    const normalStateTexture = texture( description.frames.normal )
    const pressedStateTexture = texture( description.frames.pressed )
    const disabledStateTexture = texture( description.frames.disabled || description.frames.normal )
    const overStateTexture = texture( description.frames.hover || description.frames.normal )

    const button = new Button(normalStateTexture, overStateTexture, pressedStateTexture, disabledStateTexture, description.hitArea);

    if ( description.position ) button.position.set( description.position.x, description.position.y )

    if (description.active_area){
        var lb = button.getLocalBounds();

        if (description.active_area.hasOwnProperty('circle')) {
            button.hitArea = new PIXI.Circle(lb.x + description.active_area.circle.x,
                lb.y + description.active_area.circle.y,
                description.active_area.circle.r);

        }
        else if (description.active_area.hasOwnProperty('ellipse')) {
            button.hitArea = new PIXI.Ellipse(lb.x + description.active_area.ellipse.x,
                lb.y + description.active_area.ellipse.y,
                description.active_area.ellipse.width,
                description.active_area.ellipse.height);
        }
        else if (description.active_area.hasOwnProperty('rectangle')) {
            button.hitArea = new PIXI.Rectangle(lb.x + description.active_area.rectangle.x,
                lb.y + description.active_area.rectangle.y,
                description.active_area.rectangle.width,
                description.active_area.rectangle.height);
        }
        else if (description.active_area.hasOwnProperty('polygon')) {
            button.hitArea = new PIXI.Polygon(description.active_area.polygon.points);
        }
    }

    if ( description.scale ) button.scale.set( description.scale )

    return button
}





// WEBPACK FOOTER //
// ./src/library/ui_commons.es6